import React from "react";
import DTImage from "../../assets/parinday/parinday.webp";

export default function Hero() {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-12 md:px-8 ">
        <div className="flex justify-center">
          <img
            src={DTImage}
            className="w-full h-auto max-h-[500px] md:max-h-[600px] object-contain"
            alt="img"
          />
        </div>
        <div className="flex flex-col justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center md:text-left">
            Project Parinday
          </h1>
          <p className="mt-6 text-center md:text-left">
            <span className="text-2xl font-bold text-[#FBABAD]">About</span>
            <br />
            <span className="text-[#671832] text-lg underline italic">
              Changing Minds, Breaking Stigmas
            </span>
            <br />
            <span className="text-[#671832] text-lg">
              <strong>Project Parindey</strong> is a bold and transformative
              initiative launched by{" "}
              <strong>LEO Club, University of Delhi</strong> aimed at fostering
              awareness, inclusivity, and empowerment around topics that are
              often overlooked or stigmatized in society. With a mission to
              liberate conversations and educate with empathy, Project Parindey
              addresses crucial issues related to sexual health, menstrual
              hygiene, and gender inclusivity—particularly among the youth.
              <br />
              <br />
              The word Parindey means birds—a symbol of{" "}
              <strong>freedom, fearlessness, and flight</strong>. With this
              project, we aim to unshackle minds from outdated stigmas and
              misinformation, paving the way for a more informed, respectful,
              and progressive society.The project focuses on areas such as
              menstrual hygiene, period poverty, PCOD and PCOS, cervical and
              breast cancer awareness, and gender-sensitive sex education.
              <br />
              <br />
              It also advocates for inclusive, gender-neutral menstrual
              education in schools to promote empathy and awareness across all
              genders.With every effort, Project Parindey envisions a society
              where women's health and rights are{" "}
              <strong>
                prioritized, respected, and fearlessly talked about
              </strong>
              .
            </span>
            <br />
          </p>
        </div>
      </div>
    </>
  );
}
